import { Outlet, useLocation } from "react-router-dom";
// import liznr_logo from "./Images/Liznr-final.png";
import { Stack } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LayOut.css";
const LayOut = () => {
  const location = useLocation();

  

  const hideHeaderRoutes = ["/education"];
  const hideHeader = hideHeaderRoutes.includes(location.pathname);

  const navigate = useNavigate();
  

  // // Hide header for VoiceToText route
  // const hideHeader = location.pathname === "/VoiceToText" || location.pathname === "/CreateRoom";

  const [hasOrganization, setHasOrganization] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const dashboard_backend = process.env.REACT_APP_DASHBOARD_BACKEND;
  const FetchOrganization = async () => {
    setIsLoading(true);

    try {
      const response = await axios.get(
        `${dashboard_backend}/team/workspaces/`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.status === 200) {
        setHasOrganization(response.data);
      }
    } catch (error) {
      if(error.response && error.response.status === 401){
        sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("refresh_token");
      navigate("/Login");
      }
      console.error(error);
    } finally {
      setIsLoading(false); // Stop loading after try/catch
    }
  };

  useEffect(() => {
    FetchOrganization();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

   return (
    <div id="layoutscroll" className={`h-screen grid ${hideHeader ? "grid-rows-[1fr]" : "grid-rows-[40px_1fr]"}`}>
      {/* Header (fixed height) */}
      {!hideHeader && <header className="px-2">
        <Stack
          className="text-left pb-3"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: "56px",
          }}
        >
          {isLoading ? (
            <p>Loading...</p>
          ) : hasOrganization.length > 0 ? (
            <Stack>
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {hasOrganization[0].logo && (
                  <img
                    src={hasOrganization[0].logo}
                    alt="Organization Logo"
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                )}
                <Stack
                  sx={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    display: "flex",
                    flexDirection: "column",
                    letterSpacing: "1px",
                  }}
                >
                  {hasOrganization[0].name}
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    {/* <p style={{ fontSize: "7px", fontWeight: "bold" }}>
                      Powered By
                    </p>
                    <img
                      src={liznr_logo}
                      className="w-[30px] h-[12px] image"
                      alt="logo"
                    /> */}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          ) : (
            " "
          )}
        </Stack>
      </header>}

      {/* Content Area (scrollable) */}
      <main className="overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default LayOut;
